import { NgModule } from '@angular/core';
import { AuthModule, LogLevel, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';

import { environment } from 'env/environment';

const authFactory = () => {
  const googleConfig = {
    authority: 'https://accounts.google.com',
    redirectUrl: `${window.location.origin}/app/OAuth/Google`,
    configId: environment.googleClientId,
    clientId: environment.googleClientId,
    scope: 'openid profile email',
    responseType: 'id_token token',
    silentRenew: false,
    useRefreshToken: false,
    historyCleanupOff: false,
    logLevel: LogLevel.Debug
  };

  return new StsConfigStaticLoader([googleConfig]);
};

@NgModule({
  imports: [
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory
      }
    })
  ],
  exports: [AuthModule]
})
export class AuthConfigModule { }
